import React from 'react';
import Inner from './Inner';

const Nav = () => {
  return (
    <header>
      <Inner>
        <div>
          <strong>Dribbbler Players Card.</strong>
        </div>

        <div>
          <a href="mailto:kenny@ispykenny.com" className="cta">Contact</a>
        </div>
      </Inner>
    </header>
  )
}

export default Nav;